export const services = [
  {
    slug: "programme-delivery-management",
    category: "Delivery",
    title: "Programme & Delivery Management",
    short: "Senior, hands-on delivery leadership: PI Planning, dependency management, release coordination, and SAFe, Scrum and Kanban ways of working.",
    description: "Senior, hands-on programme and delivery leadership deployed into your change initiatives, led by a certified SAFe Practice Consultant with a decade of financial-services delivery.",
    features: ["PI Planning facilitation", "Scrum, Kanban and SAFe ways of working", "Cross-functional dependency management", "Release and cutover coordination"],
    forWhom: "Programmes that need experienced delivery leadership, fast.",
  },
  {
    slug: "pmo-establishment-uplift",
    category: "PMO",
    title: "PMO Establishment & Uplift",
    short: "We stand up and run PMOs, with financial governance built in: cost, investment and benefits tracking.",
    description: "We stand up, run or mature a programme or project management office, with financial governance built in rather than bolted on, and hand it over when your team is ready.",
    features: ["PMO structure, governance & cadence", "Benefits tracking", "Reporting that executives actually read", "Cost control & investment governance"],
    forWhom: "Organisations that need delivery governance that holds.",
  },
  {
    slug: "delivery-resourcing",
    category: "Resourcing",
    title: "Quality-Assured Delivery Resourcing",
    short: "Vetted PMs, coordinators, Scrum Masters and business PMs, screened against the standards we deliver to ourselves.",
    description: "Vetted delivery professionals placed into your teams. We don't place warm bodies: every professional is screened against the delivery standards we stand behind.",
    features: ["Programme & project managers", "Business project managers", "Project coordinators & administrators", "Scrum Masters"],
    forWhom: "Teams that need to scale delivery capacity without lowering the bar.",
  },
  {
    slug: "safe-training-certification",
    category: "Training",
    title: "SAFe Training & Certification",
    short: "Certification courses led by a SAFe® Practice Consultant (SPC) — plus in-house Agile Release Train launch coaching.",
    description: "Certification courses delivered by a certified SAFe® Practice Consultant (SPC), for teams adopting or maturing SAFe — plus private, in-house coaching for teams launching Agile Release Trains.",
    features: ["Leading SAFe (SA)", "SAFe Scrum Master (SSM) certification", "SAFe for Teams & PO/PM (POPM)", "In-house ART launch coaching"],
    forWhom: "Organisations standing up SAFe, or upskilling delivery teams and release leaders.",
  },
  {
    slug: "delivery-assurance-review",
    category: "Review",
    title: "Delivery Assurance Review",
    short: "A fixed-scope, independent review of a critical programme — a clear verdict and the evidence behind it, in weeks not months.",
    description: "A fixed-scope, time-boxed independent review of a critical programme. You get a clear verdict on whether it will land and the evidence behind it — in weeks, not months. A low-commitment way to get an outside read without standing up a full assurance function.",
    features: ["Fixed scope, typically 2–4 weeks", "At feasibility, pre-PI, mid-flight or pre-go-live", "A clear go / at-risk / off-track verdict", "Evidence pack an audit committee accepts"],
    forWhom: "The sponsor or board that needs an honest, independent read on a programme that can't slip.",
  },
];

export const serviceNav = services.map(({ slug, title }) => ({ slug, title }));
